import React from 'react';

import { Skeleton } from '@material-ui/lab';

import BaseSkeleton from '../BaseSkeleton';
import Card from '../../../Card';

import { SummaryCardSkeletonProps } from './SummaryCardSkeleton.types';

const SummaryCardSkeleton: React.FC<SummaryCardSkeletonProps> = ({ className }) => {
  return (

      <Card className={`relative flex flex-justify p4 ${className}`}>
        <div className='flex flex-column'>
          <BaseSkeleton width={130} height={30} className="mb1" />
          <BaseSkeleton width={45} height={42} className="mb2" />
          <Skeleton width={100} height={50} className="mb2" />
        </div>
        <div className='flex'>
          <Skeleton variant='circle' width={36} height={36} />
        </div>
      </Card>

  );
};

export default SummaryCardSkeleton;
export { SummaryCardSkeletonProps };